<template>
  <el-dialog :title="$t('newApp.Attribute.dcoa')" :visible.sync="dialogVisible" width="1000px" class="activityDialog"
    @close="dialogCloseHandle">
    <div class="operatingFloor">
      <div class="totalAmount">{{ $t('newApp.Attribute.tp') }}：<span>{{ totalMoney | totalMoneyFilter }}</span></div>
      <el-button type="primary" @click="addRow">{{ $t('newApp.Attribute.aar') }}</el-button>
    </div>
    <commonTable ref="activityDialogTable" />
    <!--    <div class="buttonBar">-->
    <!--      <button class="common_button" @click="addRow">添加一行</button>-->
    <!--    </div>-->
    <div class="describe">
      <div class="label">{{ $t('general.Remarks') }}：</div>
      <el-input type="textarea" v-model="describe" maxlength="500" show-word-limit />
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogCloseHandle">{{ $t('btn.Cancel') }}</el-button>
      <el-button type="primary" @click="submitHandle">{{ $t('btn.OK') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { newApplicationFormApi } from '../../service';
import commonTable from '@/components/commonTable';
import { TableRow, TableColumns } from '@/utils/tableOptions.js';
export default {
  data() {
    return {
      dialogVisible: false,
      tableData: [{
        amount: 0,
        price: 0
      }],
      projectConentList: [// 项目内容列表
      ],
      totalMoney: 0,
      describe: ''
    };
  },
  props: {
    activityDialogVisible: {
      type: Boolean,
      default: false
    },
    currentRow: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  filters: {
    totalMoneyFilter(val) {
      return Number(val).toFixed(2);
    }
  },
  watch: {
    activityDialogVisible(val) {
      if (val) {
        if (this.currentRow.activityExpenseDetails && this.currentRow.activityExpenseDetails.length > 0) {
          this.tableData = this.currentRow.activityExpenseDetails;
          this.describe = this.currentRow.expenseDetailNote;
          this.totalMoney = this.currentRow.activityCost;
        }
        this.loadTable();
        this.getExpenseOptionList();
      } else {
        this.tableData = [{
          amount: 0,
          price: 0
        }];
        this.describe = '';
        this.totalMoney = 0;
      }
      this.dialogVisible = val;
    }
  },
  components: {
    commonTable
  },
  methods: {
    dialogCloseHandle() {
      this.$emit('dialogCloseHandle');
    },
    submitHandle() {
      let verification = this.tableData.every(item => {
        return item.content;
      });
      if (!verification) {
        this.$message.error(this.$t('newApp.Attribute.pspc'));
        return;
      }
      if (this.tableData && this.tableData.length > 0 && this.totalMoney <= 0) {
        this.$message.error(this.$t('newApp.Attribute.ttafcb0'));
        return;
      }
      let obj = {
        list: this.tableData,
        total: this.totalMoney,
        describe: this.describe
      };
      this.$emit('submitHandle', obj);
    },
    addRow() {
      this.$refs.activityDialogTable.insertRow({
        amount: 0,
        price: 0
      });
    },
    deleteBtn(row) {
      this.$refs.activityDialogTable.removeRow(row);
      this.moneyCount(row);
    },
    arrayQuery(val, list, findKey) {
      return list.find(item => {
        return item[findKey] === val;
      });
    },
    moneyCount(row) {
      row.price = row.price ? Number(row.price) : 0;
      row.amount = row.amount ? Number(row.amount) : 0;
      row.total = (row.price * row.amount).toFixed(2);
      this.totalMoney = this.tableData.reduce((current, item) => {
        return current + Number(item.total ? item.total : 0);
      }, 0);
    },
    getExpenseOptionList() {
      if (this.$route.path === '/quickApplicationForm' || this.$route.path === '/editQuickApplication') {
        newApplicationFormApi.getActivityList(['other_classification']).then(res => {
          if (res.status === '200') {
            this.projectConentList = res.data.other_classification;
            this.loadTable();
          }
        });
      } else {
        newApplicationFormApi.getExpenseOptionList().then(res => {
          if (res.status === '200') {
            this.projectConentList = res.data;
            this.loadTable();
          }
        });
      }
    },
    loadTable() {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Attribute.pc'))
          ._data('content')
          ._width('200')
          ._cellType('customSelect')
          ._cellData({
            options: this.projectConentList,
            optionProps: {
              label: 'fieldValue',
              value: 'fieldValue'
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Attribute.pup'))
          ._data('price')
          ._width('200')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <el-input-number
                  v-model={row[column.property]}
                  min={0}
                  controls={false}
                  precision={2}
                  onChange={() => { this.moneyCount(row); }}
                />
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Attribute.nop'))
          ._data('amount')
          ._width('180')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <el-input-number
                  v-model={row[column.property]}
                  min={1}
                  precision={0}
                  onChange={() => { this.moneyCount(row); }}
                />
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Attribute.sp'))
          ._align('right')
          ._data('total')
          ._width('120')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('general.Operation'))
          ._width('100')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button type="text" onClick={() => { this.deleteBtn(row); }}>{this.$t('btn.Delete')}</el-button>
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$nextTick(() => {
        this.$refs.activityDialogTable.setColumn(column, {
          page: false
        });
        this.$refs.activityDialogTable.loadStaticTable(this.tableData);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.activityDialog {
  .describe {
    margin: 16px 0 10px;
    border: 1px solid #DCDFE3;

    >.label {
      line-height: 40px;
      background: #F6F7F9;
      font-size: 16px;
      color: #424C57;
      padding-left: 15px;
    }

    ::v-deep>.el-textarea>textarea {
      border: none;
      min-height: 100px !important;
    }
  }
}
</style>
